import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Lang, LangEnum } from "../utils/lang"

const BlogSearch = ({ blok, category, keyword, label }) => {
  const lang = Lang()
  // console.log(blok)
  // console.log(prefecture, season, typeOfTour, keyword)
  
  const [selectedCategory, setCategory] = React.useState(category || '')

  const { categories } = useStaticQuery(graphql`
  query {
    categories: allStoryblokEntry(filter: {field_component: {eq: "category"}}) {
      edges {
        node {
          name
          full_slug
        }
      }
    }
  } 
  `)
  // console.log(categories)

  return (
    <div className="container max-w-2xl mx-auto mt-5" {...storyblokEditable(blok)}>

      <form method="GET" action={`${lang}/blogs`} className="flex flex-col sm:flex-row justify-between px-5 gap-2">
        <label className="p-3 rounded-lg border border-gray-800">
          <select name="category" className="outline-none w-full" defaultValue={category} value={selectedCategory} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Select Category</option>
            {
              categories.edges
              .filter(({ node }) => {
                if (lang === LangEnum.JA && node.full_slug?.startsWith('ja/')) return true
                if (lang === LangEnum.EN && !node.full_slug?.startsWith('ja/')) return true
                return false
               })
              .map(({ node }) => (
                <option key={node.name} value={node.name}>{node.name}</option>
              ))
            }
          </select>
        </label>

        <label className="p-3 rounded-lg border border-gray-800">
          <input type="text" name="keyword" defaultValue={keyword} placeholder="Enter keywords here" className="outline-none w-full" />
        </label>
        <button type="submit" className="bg-gray-800 text-white rounded-lg p-2">
          <img className="h-8 w-full" src="/icons/search-section-cta.svg" alt="Search Blogs" />
        </button>
      </form>
      <div className="">
        {label && label.length > 0 && <img className="w-4 h-4 align-middle mr-2 inline" src="/icons/tag.svg" alt="Tag icon" />}
        {label?.map((l) => (<span className="text-blue-700 text-xs border-b-2 border-blue-700 mr-2" key={l}>{l}</span>))}
      </div>

    </div>
  )
};

export default BlogSearch;
